<template lang="pug">
    header
      v-layout.primary.header(row wrap hidden-md-and-up)
        v-flex.shop_sm(xs12)
            v-layout(row wrap)
              v-flex.shop.white.pt-1(hidden-xs sm12)
                v-layout.justify-center.py-1.px-3(row wrap)
                  v-flex(xs4)
                    router-link(to="/top" v-scroll-to="'main'")
                      img.logo.mt-3(src="static/images/logo.png" alt="Juicies")
                  //- ショップリンク非表示
                  //-v-flex(xs4 v-for='(item, index) in shop' :key='item.key' target='_blank')
                      a(:href='item.link')
                        img(:src='item.src')
      v-layout(row wrap).special_nav.hidden-md-and-up
        v-flex(xs3 v-for="(item, index) in sNav" :key="item.key")
          router-link.snav_sp(:to="item.key")
            span.btn_wrap(:style="{backgroundColor: item.color.bg}")
              span
                p(:style="{color: item.color.text}") {{ item.title1 }}
                  br
                  | {{ item.title2 }}
                img.snav_icon(:src="item.icon.src")
      v-toolbar(fixed)
        v-toolbar-title.hidden-sm-and-down(md10)
          router-link(to="/top" v-scroll-to="'main'")
            img.logo(src="static/images/logo.png" alt="Juicies")
        v-spacer
        v-toolbar-items(row wrap).primary--text
          v-flex.normal_nav
            router-link.hidden-sm-and-down.text_nav.mt-2(
              v-for="(item, index) in textNav"
              :to="item.key"
              :key="item.key"
              ) {{item.title}}
            a.sns(
              v-for="(item, index) in sns"
              :key="item.key"
              :href="item.link"
              target="_blank"
              )
              img(:src="item.src" alt="item.key")
            //- ショップリンク非表示
            //-a.shop.hidden-sm-and-down(:href='item.link' v-for='(item, index) in shop' :key='item.key' target='_blank')
            //-img(:src='item.src')
          v-flex.hidden-sm-and-down.special_nav
            router-link.mx-1.nav_shop.snav(
            v-for="(item, index) in sNav"
            :key="item.key"
            :to="item.key"
            )
              span.btn_wrap(:style="{backgroundColor: item.color.bg}")
                i(v-for="n in 4" :style="{backgroundColor: item.color.bubble}")
                p.text-xs-center(:style="{color: item.color.text}")
                  | {{ item.title1 }}
                  br
                  | {{ item.title2 }}
              img.snav_icon(:src="item.icon.src")
        v-menu.hidden-md-and-up(xs1 transition="slide-y-transition")
          v-toolbar-side-icon.primary--text(slot="activator")
          div.navigation-drawer(style="width:300px;")
            v-list(two-line)
              v-list-tile.primary--text(
                v-for="(item, index) in spMenu"
                :key="item.key"
                :to="item.key"
                width="100%"
                @click.stop="drawer = !drawer"
                )
                v-list-tile-title {{item.title}}

      div.head_lawn
</template>

<script>
export default {
  name: 'CommonHeader',
  data: () => ({
    sNav: [{
      key: 'download',
      title1: 'アイテム',
      title2: 'ダウンロード',
      type: 's',
      color: {
        text: '3e2723',
        bg: '#ffcc00',
        bubble: '#ffef73'
      },
      icon: {
        src: require('@/../static/images/icon_download.png'),
        alt: 'カメラスタンプアイコン'
      }
    }, {
      key: 'freezer',
      title1: '店舗・施設',
      title2: 'の方へ',
      type: 's',
      color: {
        text: 'white',
        bg: '#0084c9',
        bubble: '#be75ff'
      },
      icon: {
        src: require('@/../static/images/icon_freezer.png'),
        alt: '冷凍庫アイコン'
      }
    }],
    textNav: [{
      key: 'item',
      title: '商品詳細'
    }, {
      key: 'press',
      title: '掲載情報'
    }],
    sns: [{
      /*
      key: 'facebook',
      link: 'https://www.facebook.com/OtaniTrading.Foods/',
      src: require('@/../static/images/sns_facebook.png')
    }, {
      */
      key: 'twitter',
      link: 'https://twitter.com/otani_foods?ref_src=twsrc%5Etfw',
      src: require('@/../static/images/sns_x.png')
    }, {
      key: 'instagram',
      link: 'https://www.instagram.com/juicies_jp/',
      src: require('@/../static/images/sns_instagram.png')
    }],
    shop: [{
      title: '楽天',
      key: 'rakuten',
      link: 'https://www.rakuten.co.jp/otani-trading-foods/',
      src: require('@/../static/images/badge_shop_rakuten.png')
    }, 
    {
      title: 'amazon',
      key: 'amazon',
      link: 'http://www.amazon.co.jp/dp/B08J7FNGD7?ref=myi_title_dp',
      src: require('@/../static/images/badge_shop_amazon.png')
    }
    ],
    spMenu: [{
      key: 'item',
      title: '商品詳細'
    }, {
      key: 'download',
      title: 'ダウンロード'
    }, {
      key: 'press',
      title: '掲載情報'
    }, {
      key: 'freezer',
      title: '店舗・施設の方へ'
    }, {
      key: 'contact',
      title: 'お問い合わせ'
    }]
  }),
  mounted: function () {
    this.$vuetify.theme.primary = '#3e2723'
    this.$vuetify.theme.secondary = '#ffcc00'
  }
}
</script>

<style scoped lang="stylus">

// color
$color-primary = #3e2723
$color-secondary = #ffcc00

// breakpoint
screen-xs = 600px
screen-sm = 959px
breakpoint(bpName)
    for name in bpName
        if name == 'md-up'
            @media only screen and (min-width: screen-sm + 1)
                {block}
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs + 1)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

.hover_bubble
  position relative
  overflow hidden
  z-index 1
  transition 0.5s
  i
    position absolute
    width 20%
    height 40%
    transform translateY(250%)
    border-radius 50%
    left calc((var(--n) - 1) * 20%)
    transition 0.5s
    transition-delay calc((var(--n) - 1) * 0.2s)
    margin 0 10%
    z-index -1
    &:nth-child(1)
      --n 1
    &:nth-child(2)
      --n 2
    &:nth-child(3)
      --n 3
    &:nth-child(4)
      --n 4
  &:hover
    i
      transform translateX(0) translateY(10px) scale(3.5)

header
  width 100%
  .v-toolbar
    background none
    box-shadow none
    +breakpoint(sm)
      background rgba(255,255,255,0.7)
      top 68px
      right 0px
      left 50%
      width 50%
      height 50px
      padding 5px 0
      z-index 10
  .logo
    width 120px
    cursor pointer
    +breakpoint(sm)
      width 70px
      margin 0 auto
  .normal_nav
    +breakpoint(md-up)
      border 1px solid #fafafa
      background rgba(255,255,255,0.9)
      border-bottom-right-radius 30px
      border-bottom-left-radius 30px
      height 60px
      padding 0 10px 5px 10px
    +breakpoint(sm)
      padding 10px 0
      height 50px
      padding 5px
  .text_nav
    padding 10px 10px 0
    font-size .8rem
    float left
    text-decoration none
    cursor pointer
    position relative
    display inline-block
    text-decoration none
    &::after
      position absolute
      bottom -10px
      left 0
      content ''
      width 100%
      height 2px
      background-color $color-primary
      transform scale(0, 1)
      transform-origin center top
      transition transform .2s
    &:hover
      &::after
        transform scale(1, 1)
  .sns
    padding-top 4px
    float left
    img
      width 25px
      margin 10px 4px
      +breakpoint(sm)
        width 25px
        margin 0 6px
  .shop
    padding-top 2px
    margin 0 10px 0 15px
    float left
    img
      width 100px
      +breakpoint(sm)
        margin-top 6px
      &:hover
        opacity .85
  .shop_sm
    position fixed
    height 70px
    width 100%
    z-index 5
    background white
    p
      font-weight 700
      line-height 1.2
      margin-top 13px
  .special_nav
    text-decoration none
    +breakpoint(sm)
      position fixed
      top 68px
      z-index 5
      width 100%
    a
      display inline-block
      float left
      +breakpoint(sm)
        width 50%
    .btn_wrap
      display inline-block
      @extend .hover_bubble
      +breakpoint(md-up)
        @extend .hover_bubble
      span
        display block
    .snav_icon
      z-index 2
      position absolute
      p
        padding-top 10px
        font-size .8rem
        line-height .9rem
        +breakpoint(sm)
          padding 0.5rem 0 0 0
          float left
          font-size 0.9rem
      .snav_icon
        width 40px
        margin -30px 0 0 80px
        +breakpoint(sm)
          position static
          width 25px
          margin 5px 0 0 5px
    .snav
      .btn_wrap
        width 110px
        height 55px
        border-radius 0 0 75px 75px
      p
        padding-top 8px
        font-size 0.7rem
        line-height 0.9rem
      .snav_icon
        width 30px
        margin -22px 0 0 70px
    .snav_sp
      .btn_wrap
        height 50px
        width 200%
        display flex
        flex-direction column
        justify-content center
        align-items center
      p
        padding 0.2rem 5px 0 8px
        float left
        font-size 0.85rem
        line-height 1rem
      .snav_icon
        position static
        width 20px
        margin 8px 0 0 10px

.sub-page .head_lawn
  background url(../../../../static/images/bg_lawn.png) repeat
  width 100%
  height 120px
  -webkit-mask-image url(../../../../static/images/mask_sub.svg)
  mask-image url(../../../../static/images/mask_sub.svg)
  -webkit-mask-mode alpha
  mask-mode alpha
  -webkit-mask-repeat repeat-x
  mask-repeat repeat-x
  -webkit-mask-position top
  mask-position top
  position absolute
  top 0
  +breakpoint(sm)
    display none
</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Header.vue